import { testerAccountPaths } from "configuration/app_paths";
import { getEnv } from "app/env";

export default {
  segmentWriteKey: getEnv("SEGMENT_WRITE_KEY"),
  trackedPagesPaths: [testerAccountPaths.testCycles, testerAccountPaths.performance],
};
